export default __webpack_public_path__ + "static/media/sub_banner_1.0b06867e.jpg";